import { DataSeries } from '@next/core-lib/models';
import { createAction, props } from '@ngrx/store';

import {
  GetFlockDataRequest,
  NormalizedFlockDataObject,
} from '../../models/flock-report-service.model';
import { ReportSelection } from '../../models/report.model';

export const loadData = createAction('[Report] Load data');

export const loadReport = createAction(
  '[Report] Load report',
  props<{ cycleId: number; barnId?: number; conceptId: number }>(),
);

export const loadTimeSeriesRequest = createAction(
  '[Report] Load TimeSeries request',
  props<{ getFlockDataRequest: GetFlockDataRequest }>(),
);

export const setSelectedReport = createAction(
  '[Report] Set report selection',
  props<{ reportSelection: ReportSelection }>(),
);

export const clearSelectedReport = createAction('[Report] Clear report selection');

export const refreshTimeSeries = createAction('[Report] Refresh TimeSeries');

export const loadTimeSeriesSuccess = createAction(
  '[Report] Load TimeSeries success',
  props<{ timeSeries: DataSeries<number> }>(),
);

export const convertToNormalizedFlockDataObject = createAction(
  '[Report] Convert from TimeSeries to NormalizedFlockDataObject',
  props<{ timeSeries: DataSeries<number> }>(),
);

export const setNormalizedFlockDataObject = createAction(
  '[Report] Set NormalizedFlockDataObject',
  props<{ normalizedFlockDataObject: NormalizedFlockDataObject }>(),
);

export const loadTimeSeriesFailed = createAction(
  '[Report] Load TimeSeries failed',
  props<{ error: string }>(),
);

export const clearReportState = createAction('[Report] Clears the report state');
